import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { X } from "react-feather";

// internal rebet imports
import "./stylesAppStoreWrittenReviewModal.css";

// component imports
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";

import { message } from "antd";
import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import { fetchSpecificUsersData } from "../../../../../api/CommonFunctions/CommonFunctions";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import {
  getApiErrorMessage,
  getApiSuccessMessage,
} from "../../../../../utils/ErrorUtils";
import { CloseOutlined } from "@ant-design/icons";

const AppStoreWrittenReviewModal = forwardRef(
  ({ handleCancel, data, refreshUserData }, ref) => {
    console.log("data", data);
    // non-state variables
    const token = JSON.parse(localStorage.getItem("token"));
    const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
      token?.AccessToken,
      false
    );
    // state variables
    const [isApiRunning, setIsApiRunning] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [toggleOptions, setToggleOptions] = useState([]);
    console.log("toggleOptions", data);

    const handleToggleChange = async (updatedFlag) => {
      const updatedOption = !updatedFlag.status;
      const payload = {
        wrote_appstore_review: updatedOption,
      };
      try {
        setIsApiRunning(true);
        const res = await PrivateAdminPanelInstance.patch(
          API_ROUTES.UPDATE_USER_APPSTORE_REVIEW_STATUS.replace(
            "{user_id}",
            data.user_id
          ),
          payload
        );

        setToggleOptions((prevOptions) =>
          prevOptions.map((option, index) => {
            if (index === prevOptions.length - 1) {
              return { ...option, status: updatedOption };
            }
            return option;
          })
        );

        await refreshUserData({ wrote_appstore_review: updatedOption });
        messageApi.success(
          getApiSuccessMessage(res, AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED)
        );
      } catch (error) {
        messageApi.error(
          getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED)
        );
        console.error("Update error:", error);
      } finally {
        setIsApiRunning(false);
      }
    };

    useEffect(() => {
      setToggleOptions([
        {
          id: 1,
          name: `Did ${data.username} leave a written review on the app store?`,
          status: data.wrote_appstore_review ?? false,
        },
      ]);
    }, [data]);

    useImperativeHandle(ref, () => ({
      clearFormData,
    }));

    const clearFormData = () => {
      setToggleOptions([]);
    };

    return (
      <div className="app-store-written-review-modal-container">
        {contextHolder}
        <div className="modal-header">
          <div className="modal-header-title">
            <h2 className="modal-title">
              {" "}
              {AppStrings.APP_STORE_WRITTEN_REVIEW}
            </h2>
          </div>
          <CloseOutlined onClick={handleCancel} className="close-icon" />
        </div>
        <div className="modal-content">
          <div className="modal-content-title">
            <span>
              {AppStrings.USER}: {data.username}
            </span>
          </div>
          <div className="transaction-info-item">
            <span>
              Did {data.username} leave a written review on the app store?
            </span>
            <div className="app-store-written-toggle-container">
              <span
                className={`app-store-written-toggle-status ${
                  toggleOptions[0]?.status ? "enabled" : "disabled"
                }`}
              >
                {toggleOptions[0]?.status ? "Yes" : "No"}
              </span>
            </div>
            <ToggleSwitch
              status={toggleOptions[0]?.status}
              eventCode={toggleOptions[0]?.id}
              updateEventCode={handleToggleChange}
              data={toggleOptions[0]}
              onlyUpdate={true}
            />
          </div>
        </div>
        <div className="modal-footer">
          <div className="buttons">
            <button
              className="cancel-button"
              onClick={handleCancel}
              disabled={isApiRunning}
            >
              {isApiRunning ? (
                <RebetLoader height={"20px"} width={"20px"} data-testid="loader" />
              ) : (
                AppStrings.CLOSE
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
);

export default AppStoreWrittenReviewModal;
